module.exports = __webpack_public_path__ + "static/media/Logo.ad42d6db.svg";